<template>
  <div>
    <Nav></Nav>
    <b-container fluid>
      <b-row>
        <b-col>
          <h1>Menus rappi</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p>Seleccione uno de los menus para editarlo o, crea uno nuevo

          </p>
        </b-col>
      </b-row>
      <b-row>
        
      </b-row>
      <b-row>
        <b-col md="6" cols="9">
          <b-form-group label="Menus:">
            <vu-select :reduce="(x) => x.id" v-model="actualMenuId" :options="rappiMenusOptions"></vu-select>
          </b-form-group>
        </b-col>
        <b-col md="3" cols="3">
          <b-button variant="success" size="" v-b-modal.modal-createMenu>Crear
            Menu</b-button>
        </b-col>
      </b-row>



    </b-container>
    <b-container fluid v-if="$route.params.id != undefined">
      <b-row>
        <b-col>
          <b-nav tabs>
            <!-- <b-nav-item>'s with child routes. Note the trailing slash on the first <b-nav-item> -->
            <b-nav-item :to="'/rappi/menu/' + $route.params.id" exact exact-active-class="active">General</b-nav-item>
            <b-nav-item :to="'/rappi/menu/' + $route.params.id + '/categories'" exact
              exact-active-class="active">Categorias</b-nav-item>
            <b-nav-item :to="'/rappi/menu/' + $route.params.id + '/items'" exact
              exact-active-class="active">Artículos</b-nav-item>
          </b-nav>
        </b-col>
      </b-row>
      <b-card no-body>
        <div class="m-3">
          <b-row>
            <b-col>
              <h4>Esta editando el menu: {{ menuname }}</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <router-view></router-view>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-container>
    <b-modal id="modal-createMenu" title="Crear Menu" @ok="createMenuF">
      <b-row>
        <b-col>
          <p class="my-4">Crea aqui un nuevo menu de rappi, en la pestaña sucursales, podras asignar el menu a cada
            sucursal.</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Nombre:">
            <b-form-input v-model="createMenu.name" type="text" required></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
export default {
  name: "rappi",
  components: { Nav },
  data() {
    return {
      rappiMenus: [],
      rappiMenusOptions: [],
      actualMenuId: undefined,
      createMenu: {
        name: ""
      }
    };
  },
  watch: {
    actualMenuId(to, f) {
      console.log(typeof (to))
      console.log(to)
      if (f != to && to != undefined && !isNaN(to) && this.$route.params.id != to) {
        this.$router.push({ params: { id: to } })
      }
    }
  },
  computed: {
    menuname() {
      if (this.actualMenuId != undefined && this.rappiMenus.length > 0 && this.actualMenuId > 0) {
        console.log(this.actualMenuId)
        let x = this.rappiMenus.find((x) => { return x.id == this.actualMenuId })
        return x.name
      } else {
        return ""
      }
    }
  },
  mounted() {
    this.getAllrappiMenus();
    if (!isNaN(this.$route.params.id) && this.$route.params.id != undefined) {
      this.actualMenuId = parseInt(this.$route.params.id)
    } else {
      this.actualMenuId = undefined
    }
  },
  methods: {
    getAllrappiMenus() {
      let that = this;
      axios
        .get("/rappi/menus")
        .then(function (response) {
          that.rappiMenus = response.data;
          let persfil = response.data
            .map((pers) => {
              return { id: pers.id, label: pers.name };
            });
          let persfils = [{ id: undefined, label: "" }]
          persfils.push(...persfil)
          that.rappiMenusOptions = persfils;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    createMenuF() {
      let that = this;
      axios
        .post("/rappi/menu", this.createMenu)
        .then(function (response) {
          that.getAllrappiMenus()
          that.actualMenuId = response.data.uuid
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
